<template>
    <div class="campaignTitle">
        {{ params.data.campaignTitle }}
    </div>
</template>
<script>
export default {}
</script>


<style lang="scss" scoped>

  .campaignTitle {
    white-space: initial;
    display: inline-block;
    word-wrap: break-word;
    line-height: 19px;
    max-width: 335px;
  }

</style>
